import { useContext, useRef } from "react";
import { LoginService } from "../../service/LoginService";
import { AppFunctions, AppFunctionsContext } from "../base/App";

/**
 * ログイン時の画面を表すコンポーネント
 * 
 * @returns 
 */
export default function LoginPage(): JSX.Element {

	/** APP function */
	const appFunctions = useContext<AppFunctions | undefined>(AppFunctionsContext);

	/** アクセスID */
	const username = useRef<HTMLInputElement | null>(null);

	/** パスワード */
	const password = useRef<HTMLInputElement | null>(null);

	/**
	 * ログインボタンクリック時イベント
	 * 
	 * @returns 
	 */
	const handleLoginClick = async () => {

		if ((username.current?.value || '') == '') {
			alert('アクセスIDを入力してください。');
			return;
		}
		if ((password.current?.value || '') == '') {
			alert('パスワードを入力してください。');
			return;
		}

		await new LoginService(appFunctions!).login(username.current!.value, password.current!.value);
	}

	// 描画する
	return (
		<form name="loginForm" className="form-signin">
			<h3 className="form-signin-heading">Archive検索ページログイン</h3>
			<table className="login-table">
				<tbody>
					<tr>
						<th className="login-table-th">&lt;検索用アクセスID&gt;</th>
						<td className="login-table-td"><input name="username"
							className="input-block-level" type="text" placeholder="アクセスID" ref={username} /></td>
					</tr>
					<tr>
						<th className="login-table-th">&lt;検索用パスワード&gt;</th>
						<td className="login-table-td"><input name="password"
							className="input-block-level" type="password" placeholder="パスワード" ref={password} /></td>
					</tr>
				</tbody>
			</table>
			<br />
			<button className="btn btn-large btn-primary pull-right" type="button"
				value="login" style={{ backgroundImage: 'linear-gradient(to bottom,#5c5c5c,#403f3f)', backgroundColor: '#403f3f' }} onClick={handleLoginClick} >ログイン</button>
		</form>
	);
}